/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_SettingsInputs */

const en_landing_studio_settings = /** @type {(inputs: Landing_Studio_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const zh_landing_studio_settings = /** @type {(inputs: Landing_Studio_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参数`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Landing_Studio_SettingsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_settings = /** @type {((inputs?: Landing_Studio_SettingsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_SettingsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_settings(inputs)
	return zh_landing_studio_settings(inputs)
});
export { landing_studio_settings as "landing.studio.settings" }